import React from 'react';
import PropTypes from 'prop-types';

import Home from '../components/Pages/Home';

const IndexPage = props => {
  const data = props.data.allContentfulAccueil.edges[0].node;
  const blogPosts = props.data.allContentfulBlogPost.edges;

  return <Home data={data} blogPosts={blogPosts} />;
};

export default IndexPage;

IndexPage.propTypes = {
  data: PropTypes.object,
};

export const frHomeQuery = graphql`
  query FrHomeQuery {
    allContentfulAccueil(filter: { node_locale: { eq: "fr" } }) {
      edges {
        node {
          title
          description
          node_locale
          heroBannerTexte {
            heroBannerTexte
          }
          heroImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          heroImageSmall {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          enSavoirPlus {
            enSavoirPlus
          }
          lireArticle
          marquesBannerTitle {
            marquesBannerTitle
          }
          marquesBannerBody {
            childMarkdownRemark {
              html
            }
          }
          logosMarquesFull {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          logosMarquesSmall {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          heroPhoto {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          heroPhotoSmall {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          servicesBannerTitle {
            childMarkdownRemark {
              html
            }
          }
          cardVenteTitle {
            cardVenteTitle
          }
          cardVenteBody {
            childMarkdownRemark {
              html
            }
          }
          cardInstallTitle {
            cardInstallTitle
          }
          cardInstallBody {
            childMarkdownRemark {
              html
            }
          }
          cardAnalysesTitle {
            cardAnalysesTitle
          }
          cardAnalysesBody {
            childMarkdownRemark {
              html
            }
          }
          aboutBannerTitle {
            aboutBannerTitle
          }
          aboutBannerBody {
            childMarkdownRemark {
              html
            }
          }
          carouselImages {
            title
            description
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          blogBannerTitle {
            blogBannerTitle
          }
          voirTous
          timeToRead
        }
      }
    }

    allContentfulBlogPost(
      filter: { node_locale: { eq: "fr" } }
      sort: { fields: [date], order: DESC }
      limit: 3
    ) {
      edges {
        node {
          node_locale
          author {
            firstName
            lastName
          }
          date(formatString: "DD/MM/YYYY")
          heroPhoto {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          title
          slug
          childContentfulBlogPostPostTextNode {
            childMarkdownRemark {
              excerpt
              html
              timeToRead
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.fr.js